/** Returns the canonical route for a project, or null when no project id exists. */
export function projectPath(id: string): string | null {
  const normalizedId = id.trim();
  return normalizedId ? `/projekte/${encodeURIComponent(normalizedId)}` : null;
}

export type ProjectView = "projects" | "list" | "board" | "calendar" | "gantt" | "mine";

const projectViews: readonly ProjectView[] = [
  "projects",
  "list",
  "board",
  "calendar",
  "gantt",
  "mine",
];

export function projectViewFromUrl(value: string | null): ProjectView {
  return projectViews.find((view) => view === value) ?? "projects";
}

export function projectIdsFromUrl(value: string | null): string[] {
  if (!value) return [];
  const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return [...new Set(value.split(",").filter((id) => uuid.test(id)))].slice(0, 50);
}

/** Links from a project record always open tasks with that project already selected. */
export function projectTasksPath(
  projectId: string,
  options: { newTask?: boolean; taskId?: string; readOnly?: boolean } = {},
): string | null {
  const normalizedId = projectId.trim();
  if (!normalizedId) return null;
  const params = new URLSearchParams({ ansicht: "list", projektFilter: normalizedId });
  if (options.newTask) params.set("neu", "aufgabe");
  if (options.taskId) {
    params.set("aufgabe", options.taskId);
    if (options.readOnly) params.set("lesen", "1");
  }
  return `/projekte?${params.toString()}`;
}
